import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import {
  ICreateTema,
  IListado,
  IQueryParam,
  ITema,
  IUpdateTema,
} from 'modelos/src';
import { HttpClientService } from '../http.service';
import { HelperService } from '../helper.service';
import { API } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TemasService {
  private http = inject(HttpClientService);
  private httpPublico = inject(HttpClient);

  public getFiltered(query?: IQueryParam): Promise<IListado<ITema>> {
    const params = HelperService.getQueryParams(query);
    return this.http.get(`/temas`, { params });
  }

  public getById(id: string): Promise<ITema> {
    return this.http.get(`/temas/${id}`);
  }

  /**
   * Tema de la pantalla de entrada: se pide al arrancar, sin sesión. Va sin el
   * HttpClientService porque ése, sin token, manda al login, y esa navegación
   * le gana a la del enlace con el que se abrió la app (restablecer
   * contraseña, registro).
   */
  public getActivaPublica(): Promise<ITema | null> {
    return firstValueFrom(
      this.httpPublico.get<ITema | null>(`${API}/temas/activa-publica`),
    );
  }

  public getActiva(): Promise<ITema | null> {
    return this.http.get(`/temas/activa`);
  }

  public getPreview(id: string): Promise<ITema> {
    return this.http.get(`/temas/preview/${id}`);
  }

  public create(dato: ICreateTema): Promise<ITema> {
    return this.http.post(`/temas`, dato);
  }

  public update(id: string, dato: IUpdateTema): Promise<ITema> {
    return this.http.put(`/temas/${id}`, dato);
  }

  public delete(id: string): Promise<ITema> {
    return this.http.delete(`/temas/${id}`);
  }

  public uploadAsset(id: string, file: File): Promise<{ url: string }> {
    const form = new FormData();
    form.append('file', file);
    return this.http.post(`/temas/${id}/asset`, form);
  }
}
